import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { Icon } from '../Icons'
import { Text } from '../Text'
import { breakpoint, themeColor, themeSpace } from '../theme'

const RadioPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  margin-top: 24px;
  padding-bottom: ${themeSpace(2)};
  border-radius: 4px;
`

const RadioPanelHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;

  background: ${themeColor('bgPrimary')};
`

const IconWrapper = styled.div`
  margin-right: 16px;
  font-size: 16px;
  ${breakpoint.tablet(css`
    font-size: 14px;
  `)}
`

const RadioPanelBody = styled.div`
  display: flex;
  padding: 0 16px;
  flex: 1;
`

interface RadioPanelProps {
  value: boolean
  onChange?: (active: boolean) => void
  header?: ReactNode
}

export const RadioPanel: FC<RadioPanelProps> = ({ onChange, value, header, children }) => {
  return (
    <RadioPanelContainer>
      <RadioPanelHeader onClick={() => onChange && onChange(!value)}>
        <IconWrapper>{value ? <Icon type="CheckCircleFilled" /> : <Icon type="EmptyCircle" />}</IconWrapper>{' '}
        <Text bold={value}>{header}</Text>
      </RadioPanelHeader>
      <RadioPanelBody>{children}</RadioPanelBody>
    </RadioPanelContainer>
  )
}
